import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/dist/query/react'

const pageApi = createApi({
    reducerPath: 'pageApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_BASE || '/lixiang/v25'
    }),
    endpoints(build) {
        return {
            
        }
    }
})

export const {
    useSmsMutation
} = pageApi

export default pageApi